module.exports = __webpack_public_path__ + "img/f2b5ce0181c898dc5a2fe93fb0c7564a.svg";